// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NyC4","title":"styles_title__3O6tL"};